import { Component, OnInit } from '@angular/core';
/**
 * @example
 * <lib-app-comp></lib-app-comp>
 */
@Component({
  selector: 'lib-app-comp',
  templateUrl: './comp.component.html',
  styleUrls: ['./comp.component.scss']
})
export class CompComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
